import { useEnterpriseBranding } from "../../lib/useEnterpriseBranding";

/** Compact "you're working inside <Enterprise>" banner for the scoped
 * admin pages (state / district heads). It answers the state head's
 * "view its enterprise" need without granting them the full
 * enterprise admin page (which their scope can't read). Renders
 * nothing for agrilens_super, who has no home enterprise. */
export function EnterpriseBanner() {
  const { enterprise } = useEnterpriseBranding();
  if (!enterprise) return null;
  return (
    <div className="flex items-center gap-3 bg-white rounded shadow-sm border border-gray-100 px-4 py-3">
      {enterprise.logo_url ? (
        <img
          src={enterprise.logo_url}
          alt={enterprise.name}
          className="h-10 w-10 object-contain rounded"
        />
      ) : (
        <div className="h-10 w-10 rounded bg-agrilens-green/10 flex items-center justify-center text-agrilens-green-dark font-semibold">
          {enterprise.name.slice(0, 1).toUpperCase()}
        </div>
      )}
      <div>
        <div className="text-xs uppercase tracking-wider text-gray-400">
          Enterprise
        </div>
        <div className="text-sm font-semibold text-gray-800">
          {enterprise.name}
        </div>
      </div>
    </div>
  );
}
